import React from 'react';
import Opiniones from "./Opiniones";

const ApuestasDeportivas = () => {
    return (
        <Opiniones type={"deportivas"} title={"LAS MEJORES PAGINAS DE APUESTAS DEPORTIVAS " + new Date().getFullYear()}/>
    );
}

export default ApuestasDeportivas;